import { Deserializable } from '../protocols/deserializable';

export class ContributionAccountDetails implements Deserializable {
  lastContributionAmount!: number;
  lastContributionDate!: string;

  public onDeserialize() {}
}
